var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCheckRound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12972",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39773",
    transform: "translate(-837 -593)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 912",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(837 593)",
    style: {
      fill: "#388cff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10930",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z",
    transform: "translate(839 595)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 70994",
    d: "M6327.495 12292.9a1 1 0 0 1-.707-.293l-3-3a1 1 0 0 1 1.414-1.414l2.294 2.294 4.075-4.074a1 1 0 0 1 1.414 1.414l-4.782 4.781a1 1 0 0 1-.708.292z",
    transform: "translate(-5481.168 -11686.788)",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckRound);
export default __webpack_public_path__ + "static/media/ic_check_round.6766289f403e9db3ad3acdacb21a9fa0.svg";
export { ForwardRef as ReactComponent };